import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { UrlApi } from "../../../services/apirest";
import { datosEstado } from "./constantes";

// Último error de facturación del pedido (/errores_facturacion/pedido/:id).
// onFacturar: si se pasa, muestra el botón para volver a enviar a facturar.
function DialogErrorFacturacion({ pedido, onClose, onFacturar }) {
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [falloConsulta, setFalloConsulta] = useState(false);
  const estado = datosEstado(pedido.id_estado, pedido.valor);

  useEffect(() => {
    fetch(UrlApi + "/errores_facturacion/pedido/" + pedido.id_pedido)
      .then((res) => res.json())
      .then((data) => setError(Array.isArray(data) ? data[0] || null : null))
      .catch(() => setFalloConsulta(true))
      .finally(() => setCargando(false));
  }, [pedido.id_pedido]);

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: estado.color, color: "#fff" }}>
        {estado.nombre} · Pedido #{pedido.id_pedido}
      </DialogTitle>
      <DialogContent sx={{ pt: "16px !important" }}>
        {cargando ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={28} />
          </Box>
        ) : falloConsulta ? (
          <Alert severity="error">No se pudo obtener el error de facturación.</Alert>
        ) : !error ? (
          <Alert severity="info">No hay errores de facturación registrados para este pedido.</Alert>
        ) : (
          <>
            <Alert severity="error" sx={{ whiteSpace: "pre-wrap" }}>
              {error.observaciones || "Sin descripción del error."}
            </Alert>
            <Box sx={{ display: "flex", flexWrap: "wrap", columnGap: 3, rowGap: 0.5, mt: 1.5 }}>
              {error.codigo_error ? (
                <Typography variant="body2">
                  <b>Código:</b> {error.codigo_error}
                </Typography>
              ) : null}
              {error.created_at ? (
                <Typography variant="body2">
                  <b>Fecha:</b> {moment(error.created_at).format("DD-MM-YYYY HH:mm")}
                </Typography>
              ) : null}
              {error.usuario ? (
                <Typography variant="body2">
                  <b>Usuario:</b> {error.usuario}
                </Typography>
              ) : null}
            </Box>
            {error.respuesta_afip ? (
              <Box sx={{ mt: 1.5 }}>
                <Typography variant="caption" color="text.secondary" fontWeight={700}>
                  RESPUESTA AFIP
                </Typography>
                <Box
                  component="pre"
                  sx={{
                    m: 0,
                    p: 1,
                    maxHeight: 200,
                    overflow: "auto",
                    bgcolor: "#F4F6F7",
                    borderRadius: 1,
                    fontSize: 12,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                  }}
                >
                  {error.respuesta_afip}
                </Box>
              </Box>
            ) : null}
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
        {onFacturar ? (
          <Button variant="contained" color="secondary" onClick={onFacturar}>
            Volver a facturar
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
}

export default DialogErrorFacturacion;
